import axios from 'axios';
import { getBaseUrlAnalista, ensureProtocol } from '../config/backend';

function getBase() {
  return getBaseUrlAnalista() || ensureProtocol(localStorage.getItem('ipBackend2') || '');
}
function getAuthHeaders() {
  const token = localStorage.getItem('token');
  return token ? { Authorization: token.startsWith('Bearer ') ? token : 'Bearer ' + token } : {};
}
function cfg() { return { headers: getAuthHeaders(), timeout: 20000 }; }

export async function fetchDashboards() {
  const base = getBase();
  if (!base) return [];
  try {
    const res = await axios.get(base + '/dashboards', cfg());
    return Array.isArray(res?.data) ? res.data : [];
  } catch (err) { return []; }
}

export async function fetchDashboard(id) {
  const base = getBase();
  if (!base) return null;
  try {
    const res = await axios.get(base + '/dashboards/' + id, cfg());
    return res?.data ?? null;
  } catch (err) { return null; }
}

export async function criarDashboard(body) {
  const base = getBase();
  if (!base) throw new Error('Backend não configurado');
  return axios.post(base + '/dashboards', body, cfg());
}
export async function atualizarDashboard(id, body) {
  const base = getBase();
  if (!base) throw new Error('Backend não configurado');
  return axios.put(base + '/dashboards/' + id, body, cfg());
}
export async function removerDashboard(id) {
  const base = getBase();
  if (!base) throw new Error('Backend não configurado');
  return axios.delete(base + '/dashboards/' + id, cfg());
}

export async function adicionarWidget(dashboardId, body) {
  const base = getBase();
  if (!base) throw new Error('Backend não configurado');
  return axios.post(base + '/dashboards/' + dashboardId + '/widgets', body, cfg());
}
export async function atualizarWidget(dashboardId, widgetId, body) {
  const base = getBase();
  if (!base) throw new Error('Backend não configurado');
  return axios.put(base + '/dashboards/' + dashboardId + '/widgets/' + widgetId, body, cfg());
}
export async function removerWidget(dashboardId, widgetId) {
  const base = getBase();
  if (!base) throw new Error('Backend não configurado');
  return axios.delete(base + '/dashboards/' + dashboardId + '/widgets/' + widgetId, cfg());
}

export async function calcularWidget(tipo, config) {
  const base = getBase();
  if (!base) return null;
  try {
    const res = await axios.post(base + '/dashboards/calcular', { tipo, config: config || {} }, cfg());
    return res?.data ?? null;
  } catch (err) { return { erro: err?.response?.data?.error || 'Erro ao calcular' }; }
}

export const TIPOS_WIDGET = [
  { tipo: 'sla_cumprimento', nome: 'Cumprimento de SLA', icone: 'fa-shield-alt', periodo: true },
  { tipo: 'fila_analista', nome: 'Fila por analista', icone: 'fa-users', periodo: false },
  { tipo: 'lead_cycle', nome: 'Lead / Cycle time', icone: 'fa-stopwatch', periodo: true },
  { tipo: 'fluxo_status', nome: 'Fluxo de status', icone: 'fa-stream', periodo: true },
  { tipo: 'velocity', nome: 'Velocity (sprints)', icone: 'fa-tachometer-alt', periodo: false },
  { tipo: 'contador', nome: 'Contador (filtro)', icone: 'fa-hashtag', periodo: false },
  { tipo: 'repositorios', nome: 'Repositórios', icone: 'fa-code-branch', periodo: false },
  { tipo: 'hardware', nome: 'Hardware (inventário)', icone: 'fa-microchip', periodo: false },
  { tipo: 'sprints', nome: 'Sprints (estado)', icone: 'fa-tasks', periodo: false },
];
